import { Text } from '@reveni-io/reveni-ui'

import ActionsMenu from './ActionsMenu/ActionsMenu'
import * as Styles from './styles'

const AvailabilityCriterionItem = ({ criterion, index, onEdit, onDuplicate, onDelete }) => {
  return (
    <Styles.MainContainer index={index}>
      <Styles.PositionContainer>
        <Text type="bodyMBold">#{criterion.internal_id}</Text>
      </Styles.PositionContainer>
      <Styles.ContentContainer>
        <Styles.Header>
          <Text type="bodyMBold">{criterion.name}</Text>
          <ActionsMenu criterion={criterion} onEdit={onEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
        </Styles.Header>
        {criterion.description && (
          <Styles.Description data-testid="availability-criterion-description">
            <Text type="bodyMRegular">{criterion.description}</Text>
          </Styles.Description>
        )}
      </Styles.ContentContainer>
    </Styles.MainContainer>
  )
}

export default AvailabilityCriterionItem
